import store from '@/store'
import { initCop, setUser } from '@transsion/cop'
import request from '@/utils/request'
import { Base64 } from 'js-base64'

export default async function cop() {
  if (process.env.VUE_APP_PROD_ENV !== 'hk') return

  const tokens = store.getters['user/tokens']

  try {
    const localData = JSON.parse(localStorage.getItem('tr_token_user') || '{}')
    let localUser

    if (localData[tokens?.rtoken]) {
      localUser = localData[tokens?.rtoken]
    }

    const account = store.state.user?.account || localUser?.account

    if (!account) {
      console.log('no account')
      doCop()
      return
    }

    const { user } = await request({
      url: `${window.context.uc}/api/user/v1/user/getDetailByAccountOrId`,
      method: 'post',
      data: {
        accountOrId: Base64.encode(account),
      },
    })

    if (!user) return doCop()

    const role = {
      uid: user?.userId,
      employeeNo: user?.account,
      realName: user?.fullname,
      name: user?.fullname,
      email: user?.email,
    }

    doCop(role)
  } catch (e) {
    console.log(e)
    doCop()
  }
}

function doCop(user) {
  initCop({
    applicationId: 'bpm_front',
    project: 'bpm',
    service: 'bpm-front',
    env: 'hk',
    version: '1.0.0',
    defaultPrivacyLevel: 'allow',
  })

  user && setUser(user)

  console.log('cop init success', user)
}
